import type { App } from 'vue';

import Tree from 'primevue/tree';
import TreeTable from 'primevue/treetable';
import Button from 'primevue/button';
import RadioButton from 'primevue/radiobutton';
import Card from 'primevue/card';
import Skeleton from 'primevue/skeleton';
import Tag from 'primevue/tag';
import Dialog from 'primevue/dialog';
import ConfirmDialog from 'primevue/confirmdialog';
import OverlayPanel from 'primevue/overlaypanel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Checkbox from 'primevue/checkbox';
import Portal from 'primevue/portal';
import Dropdown from 'primevue/dropdown';
import Message from 'primevue/message';
import Divider from 'primevue/divider';
import DataTable from 'primevue/datatable';
import Panel from 'primevue/panel';
import Badge from 'primevue/badge';
import MultiSelect from 'primevue/multiselect';
import AutoComplete from 'primevue/autocomplete';
import Sidebar from 'primevue/sidebar';
import Editor from 'primevue/editor';
import TreeSelect from 'primevue/treeselect';
import InputSwitch from 'primevue/inputswitch';
import InputNumber from 'primevue/inputnumber';
import Column from 'primevue/column';
import ToggleButton from 'primevue/togglebutton';
import Textarea from 'primevue/textarea';
import SelectButton from 'primevue/selectbutton';
import SplitButton from 'primevue/splitbutton';
import Calendar from 'primevue/calendar';
import CascadeSelect from 'primevue/cascadeselect';
import Chips from 'primevue/chips';
import Chip from 'primevue/chip';
import InputMask from 'primevue/inputmask';
import Listbox from 'primevue/listbox';
import Slider from 'primevue/slider';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import VirtualScroller from 'primevue/virtualscroller';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Toolbar from 'primevue/toolbar';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Menu from 'primevue/menu';
import MegaMenu from 'primevue/megamenu';
import Menubar from 'primevue/menubar';
import PanelMenu from 'primevue/panelmenu';
import Steps from 'primevue/steps';
import TieredMenu from 'primevue/tieredmenu';
import TabMenu from 'primevue/tabmenu';
import Breadcrumb from 'primevue/breadcrumb';
import ContextMenu from 'primevue/contextmenu';

// import 'primevue/resources/primevue.min.css';
// import 'primeicons/primeicons.css';

const components = {
    AutoComplete,
    Calendar,
    CascadeSelect,
    Chips,
    Chip,
    Tree,
    Tag,
    Button,
    Card,
    Skeleton,
    TreeSelect,
    TreeTable,
    InputText,
    InputSwitch,
    InputNumber,
    InputMask,
    Listbox,
    Password,
    Checkbox,
    Message,
    Dialog,
    RadioButton,
    Divider,
    Panel,
    Portal,
    Dropdown,
    Badge,
    MultiSelect,
    ConfirmDialog,
    OverlayPanel,
    Sidebar,
    DataTable,
    Column,
    Editor,
    ToggleButton,
    Textarea,
    TriStateCheckbox,
    VirtualScroller,
    ContextMenu,
    SelectButton,
    SplitButton,
    Slider,
    TabView,
    TabPanel,
    Toolbar,
    Splitter,
    SplitterPanel,
    Menu,
    TabMenu,
    Breadcrumb,
    MegaMenu,
    Menubar,
    PanelMenu,
    Steps,
    TieredMenu,
};

export default function primevueComponents(app: App) {
    Object.entries(components).forEach(([name, component]) => {
        app.component(name, component);
    });
}
